import fetchExpresso from 'utility/fetchExpresso';

import type { ReportView, ReportViewConfig, ReportViewVisibility } from './reportViewTypes';

export type UpdateReportViewInput = {
    name?: string;
    description?: string | null;
    config?: ReportViewConfig;
    visibility?: ReportViewVisibility;
};

export async function updateReportView(
    eventId: number,
    viewId: number,
    input: UpdateReportViewInput,
): Promise<ReportView> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/report-views/${viewId}`, {
        method: 'PUT',
        body: input,
    });

    if (!res.ok) {
        const error = (await res.json().catch(() => null)) as {
            message?: string;
            code?: string;
        } | null;
        const err = new Error(error?.message || 'Failed to update report view') as Error & {
            code?: string;
        };
        err.code = error?.code;
        throw err;
    }

    const data = (await res.json()) as { view: ReportView };
    return data.view;
}
